import request from '../utils/request'

export function getServerTime(requestConfig = {}) {
    return request.post('./index.php', {
        function: 'getServerTime'
    }, requestConfig)
}

export function getExamEntryDiagnostics(student_id, test_taker_id, template_id, project_code, requestConfig = {}) {
    return request.post('./index.php', {
        function: 'getExamEntryDiagnostics',
        student_id,
        test_taker_id,
        template_id,
        project_code
    }, requestConfig)
}

export function createRoomToken(room, userId, type) {
    return request.post('/Class_online/index.php', {
        function: 'createRoomToken',
        room,
        userId,
        type
    })
}

export function loginByEducator(email, pwd) {
    return request.post('./index.php', {
        function: 'loginByEducator',
        email,
        pwd
    })
}

export function loginByEmployee(email, pwd) {
    return request.post('./index.php', {
        function: 'loginByEmployee',
        email,
        pwd
    })
}

export function loginByStudent(project_bu, student_email, student_pwd) {
    return request.post('./index.php', {
        function: 'loginProjectByStudentNew',
        project_bu,
        student_email,
        student_pwd
    })
}

export function createLoginOPT(student_email, login_type) {
    return request.post('./index.php', {
        function: 'createLoginOPT',
        student_email,
        login_type
    })
}

export function loginByStudentWithOPT(student_email, verify_code) {
    return request.post('./index.php', {
        function: 'loginByStudentWithOPT',
        student_email,
        verify_code,
        project_bu: 'AM'
    })
}

export function loginByEducatorWithOPT(email, verify_code) {
    return request.post('./index.php', {
        function: 'loginByEducatorWithOPT',
        email,
        verify_code
    })
}

export function loginByEmployeeWithOPT(email, verify_code) {
    return request.post('./index.php', {
        function: 'loginByEmployeeWithOPT',
        email,
        verify_code
    })
}

export function getUserNames(project_code) {
    return request.post('./index.php', {
        function: 'getUserNames',
        project_code
    })
}

export function getMyEvents(student_id) {
    return request.post('./index.php', {
        function: 'getMyEvents',
        student_id
    })
}

export function getEventsByEducator(educator_id, project_code) {
    return request.post('./index.php', {
        function: 'getEventsByEducator',
        educator_id,
        project_code
    })
}

export function getMyZhiboRooms(student_id, BU) {
    return request.post('./index.php', {
        function: 'getMyZhiboRooms',
        student_id,
        BU
    })
}

export function getExamRooms(student_id, BU) {
    return request.post('./index.php', {
        function: 'getExamRooms',
        student_id,
        BU
    })
}

export function getExerciseTemplateByStudent(template_id, user_id, project_code) {
    return request.post('./index.php', {
        function: 'getExerciseTemplateByStudent',
        template_id,
        user_id,
        project_code,
        need_live_score: true
    })
}

export function getExerciseTemplateByTeam(template_id, user_id, project_code) {
    return request.post('./index.php', {
        function: 'getExerciseTemplateByTeam',
        template_id,
        user_id,
        project_code,
        need_live_score: true
    })
}

//废弃，不要用了
export function uploadAnswers(answers, student_id, template_id) {
    return request.post('./index.php', {
        function: 'uploadAnswers',
        answers,
        student_id,
        template_id
    })
}
export function uploadAnswersV1(project_code, answers, student_id, template_id, app_id, ip) {
    return request.post('./index.php', {
        function: 'uploadAnswers',
        project_code,
        answers,
        student_id,
        template_id,
        app_id,
        ip
    })
}

export function changeVisibleLog(student_id, project_code, template_id) {
    return request.post('/RE_Arena/index.php', {
        function: 'changeVisibleLog',
        student_id,
        project_code,
        template_id
    })
}

export function getTestVisibleChangeCount(template_id, student_id, project_code) {
    return request.post('/RE_Arena/index.php', {
        function: 'getTestVisibleChangeCount',
        template_id,
        student_id,
        project_code
    })
}

export function submitAnswer(question_id, template_id, choice, student_id, ip, test_event, project_code, answer_img_url, relay_mode, confirm_answer = false) {
    return request.post('./index.php', {
        function: 'submitAnswer',
        question_id,
        template_id,
        choice,
        student_id,
        ip,
        test_event,
        project_code,
        answer_img_url,
        relay_mode: relay_mode ? 'true' : undefined,
        need_live_score: confirm_answer,
        confirm_answer
    })
}

export function claimExamIpBinding(student_id, template_id, project_code) {
    return request.post('/RE_Arena/index.php', {
        function: 'claimExamIpBinding',
        student_id,
        template_id,
        project_code
    })
}
export function uploadAnswersV2(project_code, student_id, template_id, app_id, ip, test_event, test_type) {
    return request.post('./index.php', {
        function: 'uploadAnswersByLogs',
        project_code,
        student_id,
        template_id,
        app_id,
        ip,
        test_event,
        test_type
    })
}
export function uploadAnswersV3(project_code, student_id, template_id, app_id, ip, test_event, test_type, answers, submit_source, frontend_score) {
    return request.post('./index.php', {
        function: 'uploadAnswersByLogsNew',
        project_code,
        student_id,
        template_id,
        app_id,
        ip,
        test_event,
        test_type,
        answers,
        submit_source,
        frontend_score
    })
}
export function saveAudioRecord(user_id, section_id, template_id) {
    return request.post('./index.php', {
        function: 'saveAudioRecord',
        user_id,
        section_id,
        template_id
    })
}

export function getUser(user_id, user_type, project_code, requestConfig = {}) {
    return request.post('./index.php', {
        function: 'getUser',
        user_id,
        user_type,
        project_code
    }, requestConfig)
}
export function getEducator(user_id, project_code) {
    return request.post('./index.php', {
        function: 'getEducator',
        user_id,
        project_code
    })
}

export function getEmployee(user_id) {
    return request.post('./index.php', {
        function: 'getEmployee',
        user_id
    })
}



export function updateUserAvatar(user_id, avatar_url) {
    return request.post('./index.php', {
        function: 'updateUserAvatar',
        user_id,
        avatar_url
    })
}

export function getMyMessages(id, project_code) {
    return request.post('./index.php', {
        function: 'getMyMessages',
        id,
        project_code
    })
}

export function sendMessage(student_id, type, sender_type, content, project_code, template_name, details) {
    const payload = {
        function: 'sendMessage',
        student_id,
        type,
        sender_type,
        content,
        project_code,
        template_name
    }
    if (details !== undefined && details !== null) {
        payload.details = details
    }
    return request.post('./index.php', payload)
}





export function uploadPic(param) {
    return request.post('./index.php', param)
}

export function listRoomUsers(room) {
    return request.post('./index.php', {
        function: 'listRoomUsers',
        room
    })
}

export function getSchoolScoresByEvent(event) {
    return request.post('./index.php', {
        function: 'getSchoolScoresByEvent',
        event
    })
}

export function getAllZhiboEvents(project_code) {
    return request.post('./index.php', {
        function: 'getAllZhiboEvents',
        project_code
    })
}

export function getAllExams() {
    return request.post('./index.php', {
        function: 'getAllExams'
    })
}

export function getApplicationsByEvent(event) {
    return request.post('./index.php', {
        function: 'getApplicationsByEvent',
        event
    })
}

export function getScoresByEvent(event, project_code) {
    return request.post('./index.php', {
        function: 'getScoresByEvent',
        event,
        project_code
    })
}

export function getScoresSelf(event, user_id, project_code) {
    return request.post('./index.php', {
        function: 'getScoresSelf',
        event,
        user_id,
        project_code
    })
}

export function checkTestLinkOpen(student_id, name) {
    return request.post('./index.php', {
        function: 'checkTestLinkOpen',
        student_id,
        name
    })
}
export function checkZhiboOpen(student_id, roomId, project_code, event) {
    return request.post('./index.php', {
        function: 'checkZhiboOpen',
        student_id,
        roomId,
        project_code,
        event
    })
}

export function checkZhiboOpenQian(student_id, roomId, project_code) {
    return request.post('./index.php', {
        function: 'checkZhiboOpenQian',
        student_id,
        roomId,
        project_code
    })
}



export function checkPeixun() {
    return request.post('./index.php', {
        function: 'checkPeixun'
    })
}

export function getApplicationsByRoom(roomId) {
    return request.post('./index.php', {
        function: 'getApplicationsByRoom',
        roomId
    })
}
//废弃了
export function uploadTimeStamp(student_id, template_id, stamp) {
    return request.post('/RE_Arena/index.php', {
        function: 'uploadTimeStamp',
        student_id,
        template_id,
        stamp
    })
}

export function uploadTimeStampV1(student_id, template_id, stamp, project_code) {
    return request.post('/RE_Arena/index.php', {
        function: 'uploadTimeStamp',
        student_id,
        template_id,
        stamp,
        project_code
    })
}

export function getTimeStamp(student_id, template_id) {
    return request.post('/RE_Arena/index.php', {
        function: 'getTimeStamp',
        student_id,
        template_id
    })
}

export function getGroupAwards(project_code, event) {
    return request.post('./index.php', {
        function: 'getGroupAwards',
        project_code,
        event
    })
}

export function getAMGroupAwards(project_code, event) {
    return request.post('./index.php', {
        function: 'getAMGroupAwards',
        project_code,
        event
    })
}


export function getAwards(project_code, application_event) {
    return request.post('./index.php', {
        function: 'getAwards',
        project_code,
        application_event
    })
}

export function getAMAllScores(project_code, application_event) {
    return request.post('./index.php', {
        function: 'getAMAllScores',
        project_code,
        application_event
    })
}

export function getAMMyAward(project_code, student_id) {
    return request.post('./index.php', {
        function: 'getAMMyAward',
        project_code,
        student_id
    })
}


export function getMyAward(project_code, student_id) {
    return request.post('./index.php', {
        function: 'getMyAward',
        project_code,
        student_id
    })
}

export function getSessionList(project_code) {
    return request.post('./index.php', {
        function: 'getSessionList',
        project_code
    })
}
export function getSessionEvents(project_code, session, student_id) {
    return request.post('./index.php', {
        function: 'getSessionEvents',
        project_code,
        session,
        student_id

    })
}
export function getExerciseTestTemplate(event, project_code, type) {
    return request.post('./index.php', {
        function: 'getExerciseTestTemplate',
        event,
        project_code,
        type
    })
}
export function uploadExamShot(student_id, project_code, template_id, camera_pic, screen_pic) {
    return request.post('/RE_Arena/index.php', {
        function: 'uploadExamShot',
        student_id,
        project_code,
        template_id,
        camera_pic,
        screen_pic
    })
}


export function findMyTranscript(student_id, project_code) {
    return request.post('./index.php', {
        function: 'findMyTranscript',
        student_id,
        project_code
    })
}

export function getEventScores(event, project_code) {
    return request.post('./index.php', {
        function: 'getEventScores',
        event,
        project_code
    })
}

export function getProjectEvent(project_code) {
    return request.post('./index.php', {
        function: 'getProjectEvent',
        project_code
    })
}

export function getExerciseTemplateByStudentReview(template_id, student_id) {
    return request.post('./index.php', {
        function: 'getExerciseTemplateByStudentReview',
        template_id,
        student_id
    })
}

export function checkIsUploadTest(template_id, student_id) {
    return request.post('./index.php', {
        function: 'checkIsUploadTest',
        template_id,
        student_id
    })
}

export function initExamShotTimePoint(student_id, project_code, template_id) {
    return request.post('/RE_Arena/index.php', {
        function: 'initExamShotTimePoint',
        student_id,
        project_code,
        template_id
    })
}

export function getHomeAnnouncements() {
    return request.post('./index.php', {
        function: 'getHomeAnnouncements'
    })
}

export function uploadExamShotNew(param) {
    return request.post('/RE_Arena/index.php',
        param
    )
}

export function uploadExamShotByUrl(params) {
    return request.post('/RE_Arena/index.php', {
        function: 'uploadExamShotByUrl',
        ...params
    })
}

export function checkTranscriptOpen(project_code) {
    return request.post('./index.php', {
        function: 'checkTranscriptOpen',
        project_code
    })
}

export function test(project_code) {
    return request.post('./index.php', {
        function: 'test',
        project_code
    })
}
export function uploadTestHeartBeat(student_id, template_id, status) {
    return request.post('/RE_Arena/index.php', {
        function: 'uploadTestHeartBeat',
        student_id,
        template_id,
        status
    })
}
export function studentSignWithTemplate(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'studentSignWithTemplate',
        student_id,
        template_id,
        project_code
    })
}


export function studentUpdateTemplateWithIndex(student_id, template_id, project_code,index) {
    return request.post('./index.php', {
        function: 'studentUpdateTemplateWithIndex',
        student_id,
        template_id,
        project_code,
        index
    })
}


export function uploadStudentIdCard(student_id, template_id, project_code, pic_url) {
    return request.post('./index.php', {
        function: 'uploadStudentIdCard',
        student_id,
        template_id,
        project_code,
        pic_url
    })
}
export function getStudentIdCard(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'getStudentIdCard',
        student_id,
        template_id,
        project_code
    })
}


export function getStudentAwards(project_code, student_id) {
    return request.post('./index.php', {
        function: 'getStudentAwards',
        project_code,
        student_id
    })
}

export function getStudentTranscripts(project, student_id) {
    return request.post('./index.php', {
        function: 'getStudentTranscripts',
        project,
        student_id
    })
}


export function checkUserInvigilate(project_code, student_id) {
    return request.post('./index.php', {
        function: 'checkUserInvigilate',
        project_code,
        student_id
    })
}

export function getExamProctoringPolicy(project_code, student_id) {
    return request.post('./index.php', {
        function: 'getExamProctoringPolicy',
        project_code,
        student_id
    })
}



export function getLectureTip(student_id, project_code) {
    return request.post("./index.php", {
        function: "getLectureTip",
        student_id,
        project_code
    });
}





export function getResidueTime(project_code, student_id, event_name, videoTime) {
    return request.post('./index.php', {
        function: 'getResidueTime',
        project_code,
        student_id,
        event_name,
        videoTime
    })
}

export function getGroupId(id) {
    return request.post("./index.php", {
        function: "getGroupId",
        id
    });
}
export function saveVideoRecordPlayTime(student_id, content_id, project_code, stamp) {
    return request.post("./index.php", {
        function: "saveVideoRecordPlayTime",
        student_id,
        content_id,
        project_code,
        stamp
    });
}
export function getVideoRecordTime(student_id, content_id, project_code) {
    return request.post("./index.php", {
        function: "getVideoRecordTime",
        student_id,
        content_id,
        project_code
    });
}
export function getProjectInfo(project_code) {
    return request.post("./index.php", {
        function: "getProjectInfo",
        project_code
    });
}
export function getQiniuToken() {
    return request.post('./index.php', {
        function: 'getQiniuToken'
    })
}

export function getExamEvidenceQiniuToken(evidence_type, project_code, template_id, student_id, requestConfig = {}) {
    return request.post('./index.php', {
        function: 'getExamEvidenceQiniuToken',
        evidence_type,
        project_code,
        template_id,
        student_id
    }, requestConfig)
}

export function saveExamNavigationLog(params, requestConfig = {}) {
    return request.post('/RE_Arena/index.php', {
        function: 'saveExamNavigationLog',
        ...params
    }, requestConfig)
}

export function saveExamInteractionLog(params, requestConfig = {}) {
    return request.post('/RE_Arena/index.php', {
        function: 'saveExamInteractionLog',
        ...params
    }, requestConfig)
}

export function saveProctorEvent(params, requestConfig = {}) {
    return request.post('/RE_Arena/index.php', {
        function: 'saveProctorEvent',
        ...params
    }, requestConfig)
}

export function recordPreparedExamEntry(params, requestConfig = {}) {
    return request.post('/RE_Arena/index.php', {
        function: 'recordPreparedExamEntry',
        ...params
    }, requestConfig)
}

export function getProctorPenaltySummary(student_id, project_code, template_id, requestConfig = {}) {
    return request.post('/RE_Arena/index.php', {
        function: 'getProctorPenaltySummary',
        student_id,
        project_code,
        template_id
    }, requestConfig)
}

// Team related APIs
export function getTeamMembers(project_code, student_id) {
    return request.post('./index.php', {
        function: 'getTeamMembers',
        project_code,
        student_id
    })
}

export function getTeamMembersWithId(project_code, student_id) {
    return request.post('./index.php', {
        function: 'getTeamMembersWithId',
        project_code,
        student_id
    })
}

export function getTeamSubmissionStatus(project_code, template_id, team_id) {
    return request.post('./index.php', {
        function: 'getTeamSubmissionStatus',
        project_code,
        template_id,
        team_id
    })
}

export function confirmTeamSubmission(project_code, template_id, student_id, team_id) {
    return request.post('./index.php', {
        function: 'confirmTeamSubmission',
        project_code,
        template_id,
        student_id,
        team_id
    })
}

export function updateSectionProgress(student_id, template_id, project_code, section_index, question_index) {
    return request.post('./index.php', {
        function: 'updateSectionProgress',
        student_id,
        template_id,
        project_code,
        section_index,
        question_index
    })
}

export function getSectionProgress(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'getSectionProgress',
        student_id,
        template_id,
        project_code
    })
}

export function getIndividualExamStatus(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'getIndividualExamStatus',
        student_id,
        template_id,
        project_code
    })
}

export function completeIndividualExamSection(student_id, template_id, project_code, section_index, reason, start_next, confirmation_email = '') {
    return request.post('./index.php', {
        function: 'completeIndividualExamSection',
        student_id,
        template_id,
        project_code,
        section_index,
        reason,
        start_next,
        confirmation_email
    })
}

export function checkAMIndividualExamSubmitStatus(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'checkAMIndividualExamSubmitStatus',
        student_id,
        template_id,
        project_code
    })
}

// Relay Exam APIs
export function getRelayTeamMembers(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'getRelayTeamMembers',
        student_id,
        template_id,
        project_code
    })
}

export function getRelayTeamChat(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'getRelayTeamChat',
        student_id,
        template_id,
        project_code
    })
}

export function sendRelayTeamMessage(student_id, student_name, template_id, project_code, content) {
    return request.post('./index.php', {
        function: 'sendRelayTeamMessage',
        student_id,
        student_name,
        template_id,
        project_code,
        content
    })
}

export function checkRelayEntryCount(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'checkRelayEntryCount',
        student_id,
        template_id,
        project_code
    })
}

export function enterRelayExam(student_id, student_name, template_id, project_code) {
    return request.post('./index.php', {
        function: 'enterRelayExam',
        student_id,
        student_name,
        template_id,
        project_code
    })
}

export function confirmRelayEntry(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'confirmRelayEntry',
        student_id,
        template_id,
        project_code
    })
}

export function getRelayExamStatus(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'getRelayExamStatus',
        student_id,
        template_id,
        project_code
    })
}

export function updateRelayMemberOnlineStatus(student_id, template_id, project_code, is_online) {
    return request.post('./index.php', {
        function: 'updateRelayMemberOnlineStatus',
        student_id,
        template_id,
        project_code,
        is_online
    })
}

export function leaveRelayExam(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'leaveRelayExam',
        student_id,
        template_id,
        project_code
    })
}

export function setTemplateExamMode(template_id, exam_mode) {
    return request.post('./index.php', {
        function: 'setTemplateExamMode',
        template_id,
        exam_mode
    })
}

export function resetRelayTestData(student_id, template_id, project_code) {
    return request.post('./index.php', {
        function: 'resetRelayTestData',
        student_id,
        template_id,
        project_code
    })
}

export function verifyCrossLoginToken(cross_token, user_id, user_type, project_code) {
    return request.post('./index.php', {
        function: 'verifyCrossLoginToken',
        cross_token,
        user_id,
        user_type,
        project_code
    })
}

export function healthCheck() {
    return request.post('./index.php', {
        function: 'healthCheck'
    })
}
